<app-page-wrapper>
    <div class="onboard-wrapper">
        <div class="title-pill" *ngIf="slide !== 5">How it Works</div>
        <div class="slide" *ngIf="slide === 1">
            <app-heavy-header lineHeight="1.6" title="Just tell the AI Agent about your plans"></app-heavy-header>
            <div class="animation-wrapper">
                <div #examplePill class="example-pill">
                    {{exampleText}}
                </div>
            </div>
            <div class="description">
                Tail One connects members with similar travel plans - allowing them to connect and share flight
                reservations to fly more efficiently.
            </div>
        </div>

        <div class="slide" *ngIf="slide === 2">
            <app-heavy-header lineHeight="1.6" title="View Options or Enable AI Watcher"></app-heavy-header>
            <div class="animation-wrapper">
                <div class="watch-anime-wrap">
                    <div [id]="mapId" class="map-wrapper"></div>
                    <div class="info">
                        <div id="location" class="location">Los Angeles, CA to Jackson Hole, WY</div>
                        <div id="location-chip" class="watch-chip">Watcher Enabled</div>
                    </div>
                </div>
            </div>
            <div class="description">
                If there are current options, you can request to connect with other parties.
            </div>
            <div class="description">
                No current options? Just enable the agent to watch and email when travel plans matching yours are found.
            </div>
        </div>

        <div class="slide" *ngIf="slide === 3">
            <app-heavy-header lineHeight="1.6" title="Connect & Coordinate"></app-heavy-header>
            <div class="animation-wrapper">
                <div class="svg-anime-wrap">
                    <svg width="100%" height="100%" viewBox="0 0 962 572" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                <stop stop-color="#15171A" offset="0%"></stop>
                                <stop stop-color="#0F1012" offset="100%"></stop>
                            </linearGradient>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-2">
                                <stop stop-color="#31404E" offset="0%"></stop>
                                <stop stop-color="#252F39" offset="100%"></stop>
                            </linearGradient>
                            <linearGradient x1="70.1907782%" y1="41.780599%" x2="70.1907782%" y2="100%"
                                id="linearGradient-3">
                                <stop stop-color="#63B7FF" offset="0%"></stop>
                                <stop stop-color="#2A97F6" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Frame-Copy-2" transform="translate(0, -2)">
                                <g id="Group" transform="translate(0, 2)">
                                    <g id="people-left">
                                        <g transform="translate(119, 210)">
                                            <circle id="Oval-Copy" fill="url(#linearGradient-2)" cx="81" cy="81" r="81">
                                            </circle>
                                            <path
                                                d="M102,100.99976 C102,96.81992 98.0115111,93.26408 92.4444444,91.946 M87.6666667,101 C87.6666667,95.69816 81.2493944,91.4 73.3333333,91.4 C65.4172483,91.4 59,95.69816 59,101 M87.6666667,84.2 C92.9439611,84.2 97.2222222,79.90184 97.2222222,74.6 C97.2222222,69.298064 92.9439611,65 87.6666667,65 M73.3333333,84.2 C68.0559433,84.2 63.7777778,79.90184 63.7777778,74.6 C63.7777778,69.298064 68.0559433,65 73.3333333,65 C78.6106278,65 82.8888889,69.298064 82.8888889,74.6 C82.8888889,79.90184 78.6106278,84.2 73.3333333,84.2 Z"
                                                id="Shape" stroke="#3BA0F9" stroke-width="4.8" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </g>
                                    </g>
                                    <g id="people-right">
                                        <g transform="translate(668, 210)">
                                            <circle id="Oval" fill="url(#linearGradient-2)" cx="81" cy="81" r="81">
                                            </circle>
                                            <path
                                                d="M92.4444444,99 C92.4444444,95.02344 87.0966778,91.8 80.5,91.8 C73.9032744,91.8 68.5555556,95.02344 68.5555556,99 M102,91.80096 C102,88.84848 99.0518722,86.31096 94.8333333,85.2 M59,91.80096 C59,88.84848 61.9481278,86.31096 66.1666667,85.2 M94.8333333,75.56664 C96.2993944,74.248296 97.2222222,72.3324 97.2222222,70.2 C97.2222222,66.22356 94.0137056,63 90.0555556,63 C88.2199333,63 86.5458,63.69324 85.2777778,64.833336 M66.1666667,75.56664 C64.7004861,74.248296 63.7777778,72.3324 63.7777778,70.2 C63.7777778,66.22356 66.9864139,63 70.9444444,63 C72.7799472,63 74.4542956,63.69324 75.7222222,64.833336 M80.5,84.6 C76.54185,84.6 73.3333333,81.37656 73.3333333,77.4 C73.3333333,73.42356 76.54185,70.2 80.5,70.2 C84.45815,70.2 87.6666667,73.42356 87.6666667,77.4 C87.6666667,81.37656 84.45815,84.6 80.5,84.6 Z"
                                                id="Shape" stroke="#3BA0F9" stroke-width="4.8" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </g>
                                    </g>
                                    <path
                                        d="M474.536648,249.164711 L435.193517,320.593773 L435.193517,320.593773 C434.845919,321.219092 434.975624,321.958171 435.509983,322.478496 C436.049535,322.998866 436.905581,323.200022 437.688911,322.998866 L477.072378,312.783605 C478.064613,312.526239 478.757468,311.630745 478.757468,310.605675 L478.757468,250.250238 C478.757468,249.007597 477.750108,248.000238 476.507468,248.000238 C475.687408,248.000238 474.932292,248.446404 474.536648,249.164711 Z M484.593,312.783746 L523.98158,322.999046 L523.98158,322.999046 C524.764963,323.200201 525.615842,322.999046 526.155328,322.478676 C526.694814,321.958306 526.819393,321.219282 526.471795,320.593952 L487.128663,249.16489 C486.529143,248.076436 485.16077,247.680077 484.072316,248.279598 C483.354009,248.675241 482.907843,249.430357 482.907843,250.250417 L482.907843,310.605799 C482.907843,311.630894 483.600733,312.526405 484.593,312.783746 Z"
                                        id="flight-shape" fill="var(--primary-color)" fill-rule="nonzero"></path>
                                    <g id="tail-one-chip">
                                        <g transform="translate(389, 191)">
                                            <rect id="Rectangle-2" fill="#0a0b0b" x="0" y="0" width="183" height="183"
                                                rx="18"></rect>
                                            <g id="Group-20" transform="translate(37, 38)">
                                                <rect id="Rectangle" x="0" y="0" width="108" height="108"></rect>
                                                <path
                                                    d="M32.3731554,63.534125 L57.0041963,63.534375 L57.0041554,101.671125 L8.09638912,101.671875 C6.65148312,101.671875 5.48015538,100.500547 5.48015538,99.0556413 C5.48015538,98.4744489 5.67368061,97.9098022 6.03019367,97.4508 L32.3731554,63.534125 Z M98.0253249,6.328125 C99.3402735,6.328125 100.40625,7.39410147 100.40625,8.70905008 L100.40625,101.671875 L67.8541554,101.671125 L67.8547097,57.2129234 C67.8547097,56.2110578 67.081212,55.3898522 66.0988239,55.3139139 L65.9499696,55.3081833 L38.7621554,55.308125 L73.9467471,10.0098294 C75.7508928,7.68703407 78.5270373,6.328125 81.4681799,6.328125 L98.0253249,6.328125 Z"
                                                    id="Combined-Shape-Copy-2" fill="url(#linearGradient-3)"></path>
                                            </g>
                                        </g>
                                    </g>
                                    <rect id="ripple" stroke="#3BC65A" x="367.5" y="169" width="226" height="227"
                                        rx="29"></rect>
                                    <rect id="out-frame" x="0" y="0" width="962" height="572"></rect>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <div class="message-wrapper">
                        <div id="message-one" class="message">
                            💰 Save and fly more
                        </div>
                        <div id="message-two" class="message">
                            ♻️ Fly Greener (Avg -8K lbs CO₂)
                        </div>
                    </div>
                </div>
            </div>
            <div class="description">
                Once connected, discuss your travel plans and share of fees.
            </div>
            <div class="description">
                One party books or updates the reservation - providing the other member's information. The provider
                will reach out to confirm the sharing details.
            </div>
            <div class="description">
                This ensures you only share flights with other trusted members. No dollars changing hands.
            </div>
        </div>

        <div class="slide" *ngIf="slide === 4">
            <app-add-persistent-watcher (onClose)="completeOnboardEducation()"></app-add-persistent-watcher>
        </div>

        <div class="actions" *ngIf="slide !== 5">
            <app-primary-btn mb="12px" (click)="onClickContinue()" gradient="true">
                {{progressBtnText}}
            </app-primary-btn>
        </div>
    </div>
</app-page-wrapper>
